<template>
    <div class="full-wdith padding-box" v-loading="loading">
        <AdsEditor
            @clickReturnBtn="clickReturnCallback"
            v-if="null != shopCompany"
        />
    </div>
</template>

<script setup>

import {inject, ref, toRef, onBeforeMount, getCurrentInstance, provide} from "vue";
import companyApi from "@/request/companyApi";
import {useUserinfo} from "@/stores/userinfo";
import AdsEditor from "@/components/shopopee/ads/adsEditor.vue";

const emits = defineEmits(["clickReturnBtn"])

const { proxy } = getCurrentInstance()
const shopCompany = ref(null)
const userInfoRef = toRef(useUserinfo())
const i18n = inject("i18n")
const loading = ref(false)

function getCompanyInfo(){
    loading.value = true

    const request = companyApi.getCompanyInfo
    const params = request.getParams()

    params.companycode = userInfoRef.value.selectCompanycode

    request.send(params, (res) => {
        loading.value = false
        if (res.code == 200){
            shopCompany.value = res.detail
        }
    })
}

function getShopCompanyObj(){
    return shopCompany.value
}

function clickReturnCallback(){
    emits("clickReturnBtn")
}

provide('shopControlFunc', {
    getShopCompanyObj,
})

onBeforeMount(() => {
    getCompanyInfo()
})

</script>

<style scoped>

.full-wdith {
    width: 100%;
}

.padding-box {
    box-sizing: border-box;
    padding: 10px;
}

</style>